export async function getBasePath() {
  try {
    const response = await fetch('_basepath');
    const data = await response.json();
    return data.basePath || '';
  } catch {
    console.warn('Could not fetch base path from server, using default');
    return '';
  }
}
